module.exports = __webpack_public_path__ + "img/banner.d10e4ecf.png";